<template>
	<v-card class='vehicle-card-skeleton shadow'>
		<v-skeleton-loader
			:loading='true'
			type='card'
			width='100%'
			tile
			class='pa-4 pb-0'
		/>

		<v-skeleton-loader
			:loading='true'
			tile
			type='text'
			class='skeleton-subheader pl-4'
			style='margin-top: -8px'
			width='61%'
		/>

		<v-skeleton-loader
			:loading='true'
			type='chip, chip'
			class='skeleton-chips pl-4 d-inline-flex'
			width='98%'
			style='margin-top: 5px'
		/>

		<v-skeleton-loader
			:loading='true'
			type='list-item-avatar, list-item-avatar'
			class='skeleton-details pl-2 mt-2'
			width='97%'
			tile
		/>


		<div class='d-inline-flex px-4 justify-space-between mt-2 align-end' style='width: 100%'>
			<v-skeleton-loader
				:loading='true'
				tile
				type='heading'
				class='skeleton-price'
				width='42%'
			/>
			<v-skeleton-loader
				:loading='true'
				type='button'
				class='skeleton-button'
			/>
		</div>
	</v-card>
</template>

<script>
export default {
	name: 'VehicleCardSkeleton'
}
</script>

<style lang='scss'>
.vehicle-card-skeleton {
	min-height: 415.5px !important;

	.v-skeleton-loader__image {
		height: 181px;
	}

	.v-skeleton-loader__card-heading .v-skeleton-loader__heading {
		margin-top: 12px;
		margin-left: -6px;
	}

	.v-skeleton-loader__heading {
		width: 76%;
	}

	.v-skeleton-loader__text {
		height: 16px;
		border-radius: 12px;
	}

	.v-skeleton-loader__chip {
		width: 100%;
		margin-right: 8px;
		height: 28px;
	}

	.skeleton-details .v-skeleton-loader__avatar {
		height: 15px !important;
		width: 15px !important;
		border-radius: 50%;
	}

	.skeleton-details .v-skeleton-loader__list-item-avatar {
		height: 26px;
	}

	.v-skeleton-loader__button {
		width: 94px;
	}
}
</style>